import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        badge: {
            background: "#D9534F",
            color: "#EBEBF6",
        },
        root: {
            top: 155,
            position: "absolute",
            color: "white",
            right: 25,
            left: 25,
            marginBottom: "10px",
            verticalAlign: "middle",
            justifyContent: "center",
        },
        dropdown: {
            width: "inherit",
            background: "#FFFFFF",
            fontSize: "14px",
            margin: "0px",
            lineHeight: "14px",
            letterSpacing: "0.16px",
            color: "#445870",
            borderLeft: "0px",
            borderTop: "0px",
            borderBottom: "0px",
            borderRadius: "0px",
            fontFamily: "Gilroy Regular",
            paddingRight: "15px",
            paddingLeft: "5px",
            outline: "none",
            "&:hover": {
                background: "#D2DEF4",
            },
            "&:focus,&$selected, &$selected:hover,&:active": {
                background: "#D2DEF4 ! important",
                opacity: "0.6",
            },
        },
        bsDropdown: {
            width: "inherit",
            background: "#e9ecef",
            fontSize: "14px",
            margin: "0px",
            lineHeight: "14px",
            letterSpacing: "0.16px",
            color: "#445870",
            borderLeft: "0px",
            borderTop: "0px",
            borderBottom: "0px",
            borderRadius: "0px",
            fontFamily: "Gilroy Regular",
            paddingRight: "15px",
            paddingLeft: "5px",
            outline: "none",
            "&:hover": {
                background: "#D2DEF4",
            },
            "&:focus,&$selected, &$selected:hover,&:active": {
                background: "#D2DEF4 ! important",
                opacity: "0.6",
            },
        },

        labelStyle: {
            fontFamily: "Gilroy Regular",
            fontSize: "14px",
            lineHeight: "14px",
        },

        button: {
            color: "#FFFFFF",
            fontFamily: "Gilroy Regular",
            textTransform: "none",
            fontSize: "15px",
            height: "35px",
            outline: "none",
            borderRadius: "12px",
            background: "#D77A1C",
            marginTop: "5px",
            marginLeft: "10px",
            "&:hover,&:focus": {
                background: "#D77A1C",
                outline: "none",
            },
        },
        apply: {
            color: "#FFFFFF",
            fontFamily: "Gilroy Regular",
            textTransform: "none",
            padding: "2px",
            fontSize: "15px",
            width: "80px",
            outline: "none",
            borderRadius: "12px",
            background: "#D77A1C",
            "&:hover,&:focus": {
                background: "#D77A1C",
                color: "#FFFFFF",
                outline: "none",
            },
        },
        popper: {
            zIndex: 9999,
            border: "0px",
            margin: "0px",
            paddingTop: "4px",
        },
        paper: {
            paddingTop: "10px",
            paddingBottom: "10px",
            margin: "0px",
            border: "0px",
        },
        paperAuto: {
            paddingTop: "0px",
            paddingBottom: "10px",
            margin: "0px",
            border: "0px",
        },
        tooltip: {
            fontSize: "0.75rem",
            margin: "0px",
            marginBottom: "5px",
            fontFamily: "Gilroy Regular",
            maxWidth: 500,
        },
        autoComplete: {
            width: "260px",
            padding: "5px",
            fontSize: "14px",
            fontFamily: "Gilroy Regular",
            border: "0px",
        },
        input: {
            padding: "5px",
            fontSize: "16px",
            fontFamily: "Gilroy Regular",
            borderBottom: "1px solid #718DA8",
        },
        popperAuto: {
            width: "260px!important",
            padding: "0px",
        },
        autoPaper: {
            zIndex: 9999,
        },
        list: {
            padding: "0px",
            width: "inherit",
            "&::-webkit-scrollbar": {
                width: "10px",
                height: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
                background: "#808080",
                borderRadius: "5px",
                backgroundClip: "padding-box",
                border: "2px solid transparent",
            },
            "&::-webkit-scrollbar-track": {
                background: "#e0e0e0",
                borderLeft: "3px solid #f6f6f6",
                borderRight: "3px solid #f6f6f6",
                borderRadius: "5px",
            },
            zIndex: 15000,
        },
        option: {
            padding: "0px !important",
            fontFamily: "Gilroy Regular !important",
            lineHeight: "14px !important",
            letterSpacing: "0.16px !important",
            fontSize: "14px !important",
        },
        calender: {
            color: "white",
            background: "#283040",
            border: "0px",
            padding: "0px",
            borderBottom: "1px solid #97A4BA",
            boxShadow: "none",
            borderRadius: "0px",
            textAlign: "left" as "left",
            width: "inherit",
            outline: "none",
            height: "38px",
            alignItems: "center",
            "&::-webkit-calendar-picker-indicator": {
                cursor: "pointer",
                borderRadius: "4px",
                padding: "0px",
                outline: "none",
            },
        },
        inputStyle: {
            color: "white",
            background: "#283040",
            border: "0px",
            padding: "0px",
            borderBottom: "1px solid #97A4BA",
            boxShadow: "none",
            borderRadius: "0px",
            textAlign: "left" as "left",
            width: "inherit",
            outline: "none",
            height: "38px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        popoverContainer: {
            flexGrow: 1,
        },
        listPopover: {
            maxWidth: 500,
            maxHeight: 220,
            minWidth: 150,
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "10px",
                height: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
                background: "#808080",
                borderRadius: "5px",
                backgroundClip: "padding-box",
                border: "2px solid transparent",
            },
            "&::-webkit-scrollbar-track": {
                background: "#e0e0e0",
                borderLeft: "3px solid #f6f6f6",
                borderRight: "3px solid #f6f6f6",
                borderRadius: "5px",
            },
        },
        demo: {
            backgroundColor: theme.palette.background.paper,
        },
        title: {
            margin: theme.spacing(4, 0, 2),
        },
        calendar: {
            border: "none !important",
        },
        searchToolTip: {
            maxWidth: "500px"
        }
    })
);